export default __webpack_public_path__ + "static/dog-5c985756511ee6adfa9d8c0fde3499d2.svg";